import { Injectable } from '@angular/core';

import { UserRoleEnum } from '@shared/enums/user-role.enum';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  roles: ActiveUser.RoleModel[] = [];
  isAdmin: boolean;
  isSuperUser: boolean;
  isUser: boolean;
  executiveUser: boolean;

  constructor() { }

  clearPermissions(): void {
    this.roles = [];
    this.isAdmin = false;
    this.isSuperUser = false;
    this.isUser = false;
    this.executiveUser = false;
  }

  setPermissions(user: ActiveUser.ActiveUserModel): void {
    this.clearPermissions();
    this.roles = user.roles;

    this.roles.forEach((role) => {
      switch (role.name) {
        case UserRoleEnum.ROLE_ADMIN:
          this.isAdmin = true;
          break;
        case UserRoleEnum.ROLE_SUPERUSER:
          this.isSuperUser = true;
          break;
        case UserRoleEnum.ROLE_USER:
          this.isUser = true;
          break;
        case UserRoleEnum.ROLE_EXECUTIVE_GROUP:
          this.executiveUser = true;
          break;
        case UserRoleEnum.ROLE_GAMIFICATION_ADMIN:
          this.isUser = true;
          break;
      }
    });
  }
}
